import Checkbox from "@/common/components/Checkbox";
import { DashboardHiddenFilterProps } from "@/features/company/types/dashboards/dashboard.type";

const DashboardFilterFuelProductsOnlyHiddenFilter = ({
  value,
  onChange,
}: DashboardHiddenFilterProps) => {
  return (
    <Checkbox
      label="Filtrar por apenas combustível"
      checked={!!value}
      onChange={(event) => onChange(event.currentTarget.checked)}
    />
  );
}

export default DashboardFilterFuelProductsOnlyHiddenFilter;
